import { StyledDiv } from "./Styled"

function BoxBuy (){
    return(
        <StyledDiv>
            <p>Carrinho de compras</p>
        </StyledDiv>
    )
}

export {BoxBuy}